module.exports = __webpack_public_path__ + "static/media/dashboardmockup.077f7d82.png";